import { numberFormat } from 'utils/app.utils';
import TableRowCommon from 'component/Table/TableRowCommon'
import TableCustom from 'component/Table/TableCustom'
import * as UseStyled from 'features/report/useStyled'
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colors } from 'constants/theme'

interface FcComponent {
    page: number
    pageLimit: number
    rowCount: number
    sortBy: string
    sortType: string
    data: any
    onRequestSort: (sortBy: string, sortType: string) => void
    handleChangeRowsPerPage: (val: any) => void
    handleChangePage: (val: any) => void
}

/** Match main table's money column format (numberFormat — comma + 2 decimals) for
 *  both rows so จำนวน/จำนวนเงิน read consistently. */
const formatCell = (v: any) => {
    if (v === undefined || v === null || v === '') return '-'
    const n = Number(v)
    if (!isFinite(n)) return '-'
    return numberFormat(n)
}

export default function VisitTotal(props: FcComponent) {
    const { t } = useTranslation()

    const headCells = [
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.VISIT.APPOINTMENT_STATUS', align: 'center', class: 'text-nowrap' },
        { id: 'price', disablePadding: false, labelKey: t('REPORT.VISIT_STATUS.PAID'), align: 'right', class: 'text-nowrap' },
        { id: 'price', disablePadding: false, labelKey: t('REPORT.VISIT_STATUS.CANCEL_BILL'), align: 'right', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: t('REPORT.VISIT_STATUS.OVERDUE'), align: 'right', class: 'text-nowrap' },
        { id: 'price', disablePadding: false, labelKey: t('REPORT.VISIT_STATUS.CANCEL_VISIT'), align: 'right', class: 'text-nowrap' },
    ]

    const renderData = (data: any, no: number, dataType: "sum" | "total") => {
        const num = props.page * props.pageLimit - props.pageLimit + no + 1;
        const label = dataType === "sum" ? t('REPORT.UNIT.QTY') : t('REPORT.UNIT.QTY_PAYMENT');
        return (
            <>
                {/* แถว */}
                <TableRowCommon
                    key={num.toString() + "_count"}
                    id={no.toString() + "_count"}
                    obj={data}
                    columns={[
                        {
                            option: 'TEXT', label: label, style: {
                                color: colors.white,
                                backgroundColor: colors.themeMainColor,
                                border: '0px',
                                borderLeft: `1px solid ${colors.themeMainColor}`
                            }, align: 'center'
                        },
                        { option: 'TEXT', align: 'right', label: formatCell(data.paid) },
                        { option: 'TEXT', align: 'right', label: formatCell(data.cancelBill) },
                        { option: 'TEXT', align: 'right', label: formatCell(data.overdue) },
                        { option: 'TEXT', align: 'right', label: dataType === 'total' ? "-" : formatCell(data.cancelVisit) }
                    ]}
                />
            </>
        );
    }

    return (
        <>
            <Box sx={{ maxWidth: '640px' }}>
                <UseStyled.ResponsiveReportTable>
                    <TableCustom
                        page={props.page}
                        pageLimit={props.pageLimit}
                        sortType={props.sortType}
                        sortBy={props.sortBy}
                        rowCount={props.rowCount}
                        onSort={props.onRequestSort}
                        setPageLimit={props.handleChangeRowsPerPage}
                        setPage={props.handleChangePage}
                        headCells={headCells}
                        rowsData={[
                            ...(props.data?.sum ? [renderData(props.data.sum, 1, "sum")] : []),
                            ...(props.data?.total ? [renderData(props.data.total, 2, "total")] : [])
                        ]}

                        hidePagination={true}
                        tableMinWidth={640}
                        customScroll
                    />
                </UseStyled.ResponsiveReportTable>
            </Box>
        </>
    )
}
